import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from '@mui/material';
import { Close, Logout as LogoutIcon } from '@mui/icons-material';
import { themeColors } from '@/theme/theme';

export default function LogoutConfirmationDialog({ open, onClose, onConfirm, loading = false }) {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 1,
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center" gap={1.5}>
            <LogoutIcon sx={{ color: themeColors.primaryColor, fontSize: 28 }} />
            <Typography variant="h6" fontWeight={700}>
              Confirm Logout
            </Typography>
          </Box>
          {!loading && (
            <IconButton onClick={onClose} size="small" aria-label="Close logout dialog">
              <Close />
            </IconButton>
          )}
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          Are you sure you want to logout? You will need to verify your phone number again to log
          back in.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          disabled={loading}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: 2,
            px: 3,
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={loading}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: 2,
            px: 3,
            bgcolor: themeColors.primaryColor,
            '&:hover': {
              bgcolor: themeColors.primaryColor,
              opacity: 0.9,
            },
          }}
        >
          {loading ? 'Logging out...' : 'Yes, Logout'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
